<template>
  <b-col>
    <b-card
      v-if="!id"
      sub-title="Moje hobby pohľadničky"
      header="povolania"
      text-variant="dark"
    >
      <b-row>
        <b-col
          v-for="(item, index) in data"
          :key="index"
          deck
          sm="12"
          md="6"
          lg="4"
          style="margin-top:5px"
        >
          <postcard
            :source-pictutes="data[index].pictutes"
            :title-img="data[index].title"
            :details-img="data[index].details"
            :size-img="data[index].size"
            :material-img="data[index].material"
            :kind-img="data[index].img"
            :path-img="/povolania/ + data[index].id"
          />
        </b-col>
      </b-row>
    </b-card>
    <router-view/>
  </b-col>
</template>

<script>
import Picture from "./Picture"
import { ref, watch } from "@vue/composition-api"
export default {
  name: 'Povolania',
  components: {
    'postcard': Picture
  },
  setup(params, context) {
    const id = ref(false)
    if (context.root.$route.params.id) {
      id.value = true
    }
    watch(() => context.root.$route.params.id, (value) => { value ? id.value = true : id.value = false })
    const data = ref([
      {
        pictutes: ['/static/images/svadba/svadba1.jpg','/static/images/svadba/svadba2.jpg','/static/images/svadba/svadba3.jpg'],
        title: "Ľudový motív - 6,30 €",
        subtitle: "Pohľadnica",
        details: "...elegantné svadobné blahoželanie s folkovým nádychom ...otváracia  pohľadnica s motívmi snúbencov, tie boli vytvorené technikou decoupage, ručne vyrezané,nalepené v 3D efekte. Prizdobené perličkovými nálepkami, krémovo-modrou papierovou páskou s ľudovým motívom. Pohľadnica je vrstvená, viaže sa bielou saténovou stužkou, zadná strana a vnútro bez textu v perlovo bielej farbe. Posielam s pevnou ručne robenou obálkou.",
        size: "...cca 15 x 14,5 cm (vrátane presahujúcich častí)",
        material: "obyčajný papier, stužka",
        kind: "decoupage, cardmaking, lepenie",
        id: 3
      },
      {
        pictutes: ['/static/images/povolania/povolania1.jpg','/static/images/povolania/povolania2.jpg','/static/images/povolania/povolania3.jpg'],
        title: "Milovníčka kníh - 5,30 €",
        subtitle: "Pohľadnica",
        details: "...milá pohľadnica pre milovníčku kníh, bola vyrobené technikou decoupage, prizdobená látkovým buttonom a špagátikom, text je pečiatka, posielam spolu s pevnou ručne robenou obálkou.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, špagát",
        kind: "decoupage, cardmaking, lepenie",
        id: 2
      },
      {
        pictutes: ['/static/images/povolania/povolania4.jpg','/static/images/povolania/povolania5.jpg'],
        title: "Jazdecká - 4,50 €",
        subtitle: "Pohľadnica",
        details: "...otváracia pohľadnica pre milovníka koní a jazdenia :) s motívom jazdeckých čižiem a prilby, tie boli vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D efekte na krásny scrapbook papier v natur štýle s dreveným motívom. Pohľadnica je vrstvená, vnútro a zadná strana bez textov v perlovobielej farbe, na voľno previazaná natur špagátikom. Posielam s ručne robenou obálkou. Pohľadnička je vhodná pre dámy, pánov, ale aj menších jazdcov :)",
        size: "14,5 x 10,5 cm",
        material: "obyčajný papier, kartón, archivačný papier, špagát",
        kind: "decoupage, cardmaking, lepenie",
        id: 1
      }
    ])
    return {
      data,
      id
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Povolania.vue